import {
  Box,
  Grid,
  Icon,
  Menu,
  MenuItem,
  TextareaAutosize,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CompareInvoiceCard from "../invoice/CompareInvoiceCard";
import CoreSelect from "../../core/inputs/CoreSelect";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import {
  GENERATE_VALIDATION_ERROR,
  GENERATE_VALIDATION_SUCCESS,
  GET_FIELDS_ERROR,
  GET_FIELDS_SUCCESS,
  GET_VALIDATION_META_ERROR,
  GET_VALIDATION_META_SUCCESS,
  SAVE_VALIDATION_ERROR,
  SAVE_VALIDATION_SUCCESS,
  SET_VALIDATION_REDUCER,
} from "../../store/types/validationTypes";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CustomButton from "./CustomButton";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import CoreInput from "../../core/inputs/CoreInput";
import { processLogicType } from "./utils";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreCustomTab from "../../core/layouts/CoreCustomTab";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import { theme } from "../../config/theme";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreOutlinedButton from "../../core/inputs/CoreOutlinedButton";
// import { logic } from "./temp";
import "./style.css";
import ValidationFlowChart from "./ValidationFlowChart";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreH5 from "../../core/dataDisplay/CoreH5";
import { CoreCustomPicker } from "../../core/inputs/CoreCustomPicker";

export default function AddValidation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toolDocs = useSelector((state) => state.common.toolDocs);
  const validationSaveSuccess = useSelector(
    (state) => state.validation.validationSaveSuccess,
  );
  const validationFields = useSelector(
    (state) => state.validation.validationFields,
  );
  const validationMeta = useSelector(
    (state) => state.validation.validationMeta,
  );
  const genLogic = useSelector((state) => state.validation.genLogic);
  const validationFieldFetchSuccess = useSelector(
    (state) => state.validation.validationFieldFetchSuccess,
  );
  const validationFieldFetchError = useSelector(
    (state) => state.validation.validationFieldFetchError,
  );
  const basicDetails = useSelector((state) => state?.profile?.basic);

  const uid = useSelector((state) => state.auth?.uid);
  const [baseVal, setBaseVal] = useState({});
  const [selTool, setSelTool] = useState({});
  const [docs, setDocs] = useState([]);
  const [logic, setLogic] = useState(null);
  const [messages, setMessages] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    getValidationMeta();
    return () => {
      resetData();
    };
  }, []);

  useEffect(() => {
    if (validationSaveSuccess) {
      resetData();
      navigate("/validations");
    }
  }, [validationSaveSuccess]);

  const resetData = () => {
    setMessages(null);
    dispatch({
      type: SET_VALIDATION_REDUCER,
      payload: {
        validations: [],
        getValidationsSuccess: false,
        getValidationsError: false,
        validationSaveSuccess: false,
        validationSaveError: false,
        genLogic: null,
      },
    });
  };

  useEffect(() => {
    let mes = [...(messages || [])];
    if (mes.length > 0) {
      if (mes.length === 1) {
        mes.push({
          type: "action",
          user: "system",
          data: toolDocs ? (
            <div>
              <CoreCustomPicker
                label={"Choose use case: "}
                data={Object.keys(toolDocs)}
                onPick={(tool) => {
                  changeTool(tool);
                  mes = [...(messages || [])];
                  mes.push({
                    type: "message",
                    user: "user",
                    data: "Use case: " + tool,
                  });
                  setMessages(mes);
                }}
              />
            </div>
          ) : null,
        });
        setMessages(mes);
      }
    }
    return () => {};
  }, [messages]);

  useEffect(() => {
    if (docs.length > 0 && selTool) {
      let mes = [...(messages || [])];
      mes.push({
        type: "action",
        user: "system",
        data: (
          <div>
            <CoreCustomPicker
              data={docs}
              label="Choose Document Type: "
              onPick={(doc) => {
                setBaseVal({ ...baseVal, docType: doc.label });
                let mes = [...messages];
                mes.push({
                  type: "message",
                  user: "user",
                  data: "Document type: " + doc.label,
                });
                setMessages(mes);
              }}
            />
          </div>
        ),
      });
      setMessages(mes);
    }
  }, [docs]);

  useEffect(() => {
    if (baseVal.docType) {
      let mes = [...(messages || [])];
      mes.push({
        type: "action",
        user: "system",
        data: (
          <div>
            <CoreCustomPicker
              label="Choose Logic type"
              data={Object.keys(validationMeta.types)}
              onPick={(log) => {
                setBaseVal({ ...baseVal, logicType: log });
                let mes = [...messages];
                mes.push({
                  type: "message",
                  user: "user",
                  data: "Logic type: " + log,
                });
                setMessages(mes);
              }}
            />
          </div>
        ),
      });
      setMessages(mes);
    }
  }, [baseVal.docType]);

  useEffect(() => {
    if (baseVal.logicType) {
      generateValidationLogic();
    }
    return () => {};
  }, [baseVal.logicType]);

  useEffect(() => {
    if (genLogic && messages?.length > 0) {
      let mes = [...(messages || [])];
      mes.push({
        type: "json",
        user: "system",
        data: genLogic,
      });
      setMessages(mes);
      setLogic(genLogic);
    }
    return () => {};
  }, [genLogic]);

  useEffect(() => {
    let elem = document.getElementById("json");
    if (logic && elem) {
      document.getElementById("json").innerHTML = syntaxHighlight(genLogic);
    }
  }, [logic]);

  const changeTool = (tool) => {
    setSelTool(tool);
    if (toolDocs[tool]) {
      setDocs(
        toolDocs[tool]?.map((doc) => {
          return { label: doc.name, value: doc.id };
        }),
      );
    }
  };

  const getFields = (docId) => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/masterData",
        {},
        {
          id: docId,
          level: 4,
          _status: "active",
        },
        null,
        GET_FIELDS_SUCCESS,
        GET_FIELDS_ERROR,
        true,

        true,
      ),
    );
  };

  const getValidationMeta = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/validation/meta",
        {},
        {},
        null,
        GET_VALIDATION_META_SUCCESS,
        GET_VALIDATION_META_ERROR,
        true,
        true,
      ),
    );
  };

  const saveValidationLogic = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/validation/add",
        {
          name: baseVal.docType + "-validation-" + logic?.logicName,
          logicText: messages[0].data,
          extraInfo: logic,
        },
        {},
        null,
        SAVE_VALIDATION_SUCCESS,
        SAVE_VALIDATION_ERROR,
        true,
        false,
      ),
    );
  };

  const addPart = () => {
    if (logic) {
      if (baseVal?.logicType === logic.type) {
        let temp = processLogicType(logic, baseVal);
        setLogic(temp);
      } else {
        alert("current type and new type not same");
      }
    } else {
      let temp = processLogicType(logic, baseVal);
      setLogic(temp);
    }
  };

  const generateValidationLogic = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/validation/generate",
        {
          logicType: baseVal.logicType,
          docType: baseVal.docType,
          text: messages[0].data,
        },
        {},
        null,
        GENERATE_VALIDATION_SUCCESS,
        GENERATE_VALIDATION_ERROR,
        true,
        false,
      ),
    );
  };

  const onMessage = (e) => {
    e.preventDefault();
    let mes = [
      ...(messages || []),
      { type: "message", user: "user", data: message },
    ];
    setMessages(mes);
  };

  const syntaxHighlight = (obj) => {
    let jsonStr = JSON.stringify(obj, null, 2);
    return jsonStr.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|\b\d+(\.\d+)?\b)/g,
      (match) => {
        let cls = "number";
        if (/^"/.test(match)) cls = /:$/.test(match) ? "key" : "string";
        else if (/true|false/.test(match)) cls = "boolean";
        else if (/null/.test(match)) cls = "null";
        return `<span class="${cls}">${match}</span>`;
      },
    );
  };

  const boxHeight = "30vh";
  console.log("validationme", baseVal, messages, toolDocs);
  return (
    <Box>
      {/* <Grid container spacing={2}> */}
      <CompareInvoiceCard>
        <div style={{ height: "100%", overflow: "auto" }}>
          {!messages ? (
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                color: theme.palette.primary.main,
              }}
            >
              <div>
                <CoreH5>
                  Hi{" "}
                  {basicDetails?.firstName && basicDetails?.firstName.length > 0
                    ? basicDetails?.firstName + ", "
                    : "User,"}
                  ! 👋 Welcome to docXplor. <br /> Please type the validation
                  logic to add
                </CoreH5>
                <form
                  onSubmit={onMessage}
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    marginTop: 16,
                  }}
                >
                  <CoreInput
                    // style={{ width: "97%" }}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                    label="Type your logic here"
                  />
                  <CoreIconButton color="primary" type="submit">
                    <Icon>send</Icon>
                  </CoreIconButton>
                </form>
              </div>
            </div>
          ) : (
            <div style={{ height: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  height: 100,
                }}
              >
                {messages?.map((mess) =>
                  mess.user === "user" ? (
                    <div
                      style={{
                        padding: 4,
                        // backgroundColor: theme.palette.grey[200],
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: theme.palette.primary.main,

                        borderRadius: 10,
                        width: 300,
                        marginTop: 8,
                        paddingLeft: 16,
                      }}
                    >
                      <CoreTypographyBody1
                        style={{ color: theme.palette.primary.main }}
                      >
                        {mess.data}
                      </CoreTypographyBody1>
                    </div>
                  ) : null,
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 450,
                  width: "100%",
                  overflow: "auto",
                  paddingTop: 16,
                }}
              >
                {messages?.map((mess, i) =>
                  mess.type === "json" ? (
                    messages && messages[0] && genLogic && mess.data ? (
                      <div
                        key={"system-" + i}
                        style={{ height: "100%", width: "100%" }}
                      >
                        <ValidationFlowChart
                          data={[{ data: mess?.data, logic: messages[0].data }]}
                        />
                        <CoreButtonContainer>
                          <CoreContainedButton
                            color="error"
                            onClick={resetData}
                          >
                            Retry
                          </CoreContainedButton>
                          <CoreContainedButton
                            onClick={saveValidationLogic}
                            style={{ marginLeft: 16 }}
                          >
                            Perfect
                          </CoreContainedButton>
                        </CoreButtonContainer>
                      </div>
                    ) : null
                  ) : mess.type === "action" ? (
                    <div
                      key={"system-" + i}
                      style={{ padding: 16, height: "100%" }}
                    >
                      {mess.data}
                    </div>
                  ) : null,
                )}
              </div>
            </div>
          )}
        </div>
      </CompareInvoiceCard>
      {/* </Grid> */}
    </Box>
  );
}
